var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"nv-list-item"},[_c('div',{staticClass:"nv-list-item_chk"},[_c('Checkbox',{on:{"on-change":_vm.doChange},model:{value:(_vm.listChk),callback:function ($$v) {_vm.listChk=$$v},expression:"listChk"}})],1),_c('div',{staticClass:"nv-list-item_content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }